import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { HOST } from 'config/config';
import useToast from 'services/Hooks/useToast';

export const useDealer = () => {
  const { errorMessage } = useToast();
  const query = useQuery({
    queryKey: ['dealer'],
    queryFn: async () => {
      const response = await axios.get(HOST + '/api/dealer-portal/dealers/current');
      return response.data;
    },
    throwOnError: errorMessage,
  });
  return query;
};

export const useDealers = (isLogged, isDemo) => {
  const { errorMessage } = useToast();
  const query = useQuery({
    queryKey: ['dealers'],
    queryFn: async () => {
      const response = await axios.get(HOST + '/api/dealer-portal/dealers/available');
      return response.data;
    },
    throwOnError: errorMessage,
    enabled: !!isLogged && !!isDemo,
  });
  return query;
};

/**
 * Fetch dealer by ID
 * @param {string} dealerId - The dealer ID
 */
export const useCertificationToolDealer = (dealerId, queryOptions = {}) => {
  const { enabled: enabledOverride, ...restOptions } = queryOptions ?? {};

  return useQuery({
    queryKey: ['dealer', dealerId],
    queryFn: async () => {
      if (!dealerId) {
        throw new Error('Dealer ID is required');
      }
      const response = await axios.get(`${HOST}/api/certification-tool/dealers/${dealerId}`);
      return response.data;
    },
    enabled: !!dealerId && (enabledOverride ?? true),
    staleTime: 5 * 60 * 1000, // 5 minutes
    ...restOptions,
  });
};
